import {Chapter} from "./chapter.js";

export class Book {
    constructor(name, chapterCount, chapters, loggedBy) {
        this.name = name;
        this.chapterCount = chapterCount;
        this.chapters = chapters;
        this.loggedBy = loggedBy;
    }

    static from_json(json) {
        const chapters = [];
        json.chapters.forEach(chapter => chapters.push(Chapter.from_json(chapter)));
        return new Book(json.name, json.chapterCount, chapters, json.loggedBy);
    }

    get_name() {
        return this.name;
    }

    get_chapter_count() {
        return this.chapterCount;
    }

    get_chapters() {
        return this.chapters;
    }

    get_logged_by() {
        return this.loggedBy;
    }
}